<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import {
    OveviewChart,
    activitiesData
} from "./data";

import { getcoinbalance, getfinancialrecords, getAssetValue } from '@/api/user'
/**
 * Wallets component
 */
export default {
    page: {
        title: "Wallets",
        meta: [{
            name: "description",
            content: appConfig.description,
        }, ],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            OveviewChart: OveviewChart,
            activitiesData: activitiesData,
            title: "Wallets",
            items: [{
                    text: "Crypto",
                    href: "/",
                },
                {
                    text: "Wallets",
                    active: true,
                },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "id",
            sortDesc: false,
            fields: [{
                    key: "id",
                    sortable: true,
                },
                {
                    key: "date",
                    sortable: true,
                },
                {
                    key: "type",
                    sortable: true,
                },
                {
                    key: "currency",
                    sortable: true,
                },
                {
                    key: "amount",
                    sortable: true,
                },
                {
                    key: "usd",
                    sortable: true,
                },
            ],
            financialrecordsfields: [
                {
                    key: "id",
                    sortable: true,
                },
                {
                    key: "createDatetime",
                    sortable: true,
                },
                {
                    key: "contractCode",
                    sortable: true,
                },
                {
                    key: "recordType",
                    sortable: true,
                },
                {
                    key: "amount",
                    sortable: true,
                },
                {
                    key: "exchangeName",
                    sortable: true,
                },
            ],
            financialrecords: [],
            userName: '',
            userId: '',
            user: [],
            exchangeName: '',
            coinbalance: [],
            assetValueSeries: [],
            assetValueObject: [],
            assetValueOption: [],
            testdata: {
                series: [
                {
                    name: "aa",
                    type: 'area',
                    data: [1,2,3,4,5]
                }
                ],
                chartOptions: {
                    chart: {
                        height: 240,
                        type: 'area',
                        toolbar: {
                            show: false
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 2,
                        dashArray: 0
                    },
                    fill: {
                        type: 'solid',
                        opacity: 0.1,
                    },
                    // xaxis: {
                    //     categories: ["a", "b", "c", "d", "e"]
                    // },
                    colors: ['#f1b44c']
                }
            }

        };
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.financialrecords.length;
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;

        // this.user = JSON.parse(localStorage.getItem('user'))
        // this.userName = this.user['userName']
        // this.userId = this.user['userId']
        //
        // this.exchangeName = localStorage.getItem('exchangeName')

        // getcoinbalance(this.exchangeName, this.userId).then(res => {
        //     this.coinbalance = res['data']
        //
        //     for (var i=0;i<this.coinbalance.length;i++)
        //     {
        //         if (i==1)
        //         {
        //             console.log("i: "+ this.coinbalance[i]['symbol'])
        //             console.log('testdata before: ', this.testdata)
        //             getAssetValue(this.exchangeName, this.userId, this.coinbalance[i]['symbol']).then(res2 => {
        //             // console.log('asset value: ' + res2['data']['datetime'])
        //             // console.log('asset value: ' + res2['data']['assetvalue'])
        //
        //             // this.assetValueObject['datetime'] = res2['data']['datetime']
        //             // this.assetValueObject['data'] = res2['data']['assetvalue']
        //             // this.assetValueObject['name'] = this.coinbalance[i]['symbol']
        //             // this.assetValueObject['type'] = 'area'
        //
        //
        //             this.testdata['series']['data'] = res2['data']['assetvalue']
        //             console.log('testdata after: ', this.testdata)
        //
        //             this.$refs.assetChart.updateSeries([{
        //                 data: res2['data']['assetvalue']
        //             }])
        //
        //             this.$refs.assetChart.updateOptions([{
        //                 xaxis: {
        //                     categories: res2['data']['datetime']
        //                 }
        //             }])
        //             // this.assetValueSeries.push(this.assetValueObject)
        //             // console.log('assetValueSeries: ' + this.assetValueSeries[0]['assetvalue'])
        //
        //             console.log('res2: ', res2)
        //
        //         }).catch(error2 => {
        //             console.log('error2: ', error2)
        //         })
        //         }
        //
        //     }
        // }).catch(error => {
        //     console.log(error)
        // })
        //
        // getfinancialrecords(this.exchangeName, this.userId).then(res1 => {
        //     this.financialrecords = res1['data']
        // }).catch(error1 => {
        //     console.log(error1)
        // })


    },
    methods: {
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    },
};
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="mr-4">
                <i class="mdi mdi-account-circle text-primary h1" />
              </div>

              <div class="media-body">
                <div class="text-muted">
                  <h5>{{ this.userName }}</h5>
                  <!-- <p class="mb-1">henrywells@abc.com</p> -->
                  <p class="mb-0">
                    Id no: {{ this.userId }}
                  </p>
                </div>
              </div>

              <b-dropdown
                class="ml-2 p-0"
                right
                variant="white"
                toggle-class="p-0"
              >
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-horizontal font-size-18" />
                </template>
                <b-dropdown-item>Action</b-dropdown-item>
                <b-dropdown-item>Another action</b-dropdown-item>
                <b-dropdown-item>Something else here</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="card-body border-top">
            <div class="row">
              <div class="col-sm-6">
                <div>
                  <p class="text-muted mb-2">
                    Available Balance
                  </p>
                  <h5>$ 9148.23</h5>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="text-sm-right mt-4 mt-sm-0">
                  <p class="text-muted mb-2">
                    Since last month
                  </p>
                  <h5>
                    + $ 248.35
                    <span class="badge badge-success ml-1 align-bottom">+ 1.3 %</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body border-top">
            <p class="text-muted mb-4">
              In this month
            </p>
            <div class="text-center">
              <div class="row">
                <div class="col-sm-4">
                  <div>
                    <div class="font-size-24 text-primary mb-2">
                      <i class="bx bx-send" />
                    </div>

                    <p class="text-muted mb-2">
                      Send
                    </p>
                    <h5>$ 654.42</h5>

                    <!-- <div class="mt-3">
                                        <a href="#" class="btn btn-primary btn-sm w-md">Send</a>
                                    </div> -->
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="mt-4 mt-sm-0">
                    <div class="font-size-24 text-primary mb-2">
                      <i class="bx bx-import" />
                    </div>

                    <p class="text-muted mb-2">
                      receive
                    </p>
                    <h5>$ 1054.32</h5>

                    <!-- <div class="mt-3">
                                        <a href="#" class="btn btn-primary btn-sm w-md">Receive</a>
                                    </div> -->
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="mt-4 mt-sm-0">
                    <div class="font-size-24 text-primary mb-2">
                      <i class="bx bx-wallet" />
                    </div>

                    <p class="text-muted mb-2">
                      Withdraw
                    </p>
                    <h5>$ 824.34</h5>
                    <!-- 
                                    <div class="mt-3">
                                        <a href="#" class="btn btn-primary btn-sm w-md">Withdraw</a>
                                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="row">
          <div
            v-for="coin in coinbalance"
            :key="coin.id"
            class="col-sm-4"
          >
            <!-- {{coin.coinName}} -->
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="mr-3 align-self-center">
                    <i class="mdi mdi-bitcoin h2 text-warning mb-0" />
                  </div>
                  <div class="media-body">
                    <p class="text-muted mb-2">
                      {{ coin.symbol }} Wallet
                    </p>
                    <h5 class="mb-0">
                      {{ coin.amount }} {{ coin.symbol }}
                      <!-- <span class="font-size-14 text-muted"> = $ 9148.00 </span> -->
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Overview
            </h4>
            <div>
              <div
                id="overview-chart"
                class="apex-charts"
                dir="ltr"
              />
              <!-- <apexchart class="apex-charts" height="240" type="line" dir="ltr" :series="OveviewChart.series" :options="OveviewChart.chartOptions"></apexchart> -->
              <apexchart
                ref="assetChart"
                class="apex-charts"
                height="240"
                type="line"
                dir="ltr"
                :series="this.testdata.series"
                :options="this.testdata.chartOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              财务记录
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="financialrecords"
                    :fields="financialrecordsfields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
